<template>
  <div class="cotton-monitor-report" ref="container">
    <MCard
      class="content"
      :title="title"
      theme="light"
      title-align="center"
      :icon="icon"
      ref="content"
    >
      <div class="cotton-monitor-report_content">
        <div class="cotton-monitor-report_content-left">
          <div
            class="fr01-device-item"
            v-for="device in deviceList"
            :key="device.sn"
            :style="{ '--state-color': getStateOpt(device).c2 }"
          >
            <div class="fr01-device-item_header">
              <span>{{ device.name }} ({{ getStateOpt(device).t }})</span>
            </div>
            <div class="fr01-device-item_content">
              <div class="fr01-device-item_handler">
                <el-button
                  class="cotton-button"
                  type="primary"
                  size="small"
                  @click.stop="openDeviceInfoWindow(device)"
                >
                  设备信息
                </el-button>

                <!-- :disabled="isOffline(device)" -->

                <!-- <el-button
                  class="cotton-button"
                  type="primary"
                  size="small"
                  :disabled="isOffline(device)"
                  @click.stop="openParamsSettingsWindow(device)"
                >
                  参数调整
                </el-button> -->
              </div>
            </div>
          </div>
        </div>
        <div class="cotton-monitor-report_content-right">
          <MTable
            i18n-path="query"
            :loading="loading"
            :tableData="cd603DetectionData"
            :tableColumn="tableColumn"
            :hasPagination="false"
            height="100%"
          >
            <template #gps="{ value, row }">
              <div class="gps" @click="locateTo(row)" :title="$t('地图查看位置')">
                <span class="iconfont icon-position-base"></span>
                <span class="gps-text">
                  {{ `${$t('经度')}: ${value[0]} \n ${$t('纬度')}: ${value[1]}` }}
                </span>
              </div>
            </template>
            <template #battery="{ row }">
              <MBatteryInfo
                :batteryPercent="row.batteryPercent"
                style="--color: var(--cotton-detection-battery-color)"
                :isCharging="row.isCharging"
              />
            </template>
            <template #result="{ value }">
              <span :style="{ color: cottonResultStateOptionGetter(value, 'color') }">
                {{ value | cottonResultStateTextGetter | translateTo('query') }}
              </span>
            </template>
          </MTable>
        </div>
      </div>
    </MCard>
  </div>
</template>

<script>
import anime from 'animejs';

import MTable from '@/components/mTable/m-table.vue';
import MCard from '@/components/mCard/index.vue';
import MBatteryInfo from '@/components/mBatteryInfo/index.vue';

import { isEmpty } from '@/utils/is';
import { getStateHighLevelOptionBy, isOffline } from '@/utils/deviceUtils/state';

import { cottonResultStateUtils } from '../../utils/status';

import { openDeviceInfoPopover } from '@/views/cotton/monitor/utils/contextMenu';
import { mapState } from 'vuex';

export default {
  mixins: [cottonResultStateUtils.mixins],
  components: { MTable, MCard, MBatteryInfo },
  inject: ['openParamsDialog', 'getCd603DetectionData', 'locateTo'],
  props: {
    deviceList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isOffline,
      icon: {
        type: 'image',
        config: {
          src: '/static/image/cotton/detection.png'
        }
      },
      reportCollapse: true,
      loading: false,
      tableColumn: [
        { label: '设备号', prop: 'sn' },
        { label: '棉包条纹码', prop: 'stripeCode' },
        { label: '检测结果', prop: 'result', slot: 'result' },
        {
          label: '定位信息',
          prop: 'gps',
          slot: 'gps'
        },
        {
          label: '设备电量',
          prop: 'battery',
          slot: 'battery'
        },
        {
          label: '扫描时间',
          prop: 'datetime'
        }
      ]
    };
  },
  computed: {
    ...mapState('socket', ['deviceIdMap']),
    title() {
      const id = this.$route.params.id;

      return `${this.$t('检测设备')}(${this.deviceIdMap[id]?.name})`;
    },
    cd603DetectionData() {
      const list = this.getCd603DetectionData();

      return list;
    }
  },
  methods: {
    async openDeviceInfoWindow(device) {
      openDeviceInfoPopover({
        sn: device.sn,
        name: device.name
      });
    },
    openParamsSettingsWindow(device) {
      this.openParamsDialog({ sn: device.sn, deviceType: device.deviceType });
    },
    getStateOpt(row) {
      const state = isEmpty(row.state2) ? -1 : row.state2;
      const runstate = isEmpty(row.runstate) ? -1 : row.runstate;

      const opt = getStateHighLevelOptionBy([{ state2: state, runstate }], { useLevel2: true });

      if (isEmpty(opt)) return {};

      return opt;
    },
    changeCollapse() {
      this.reportCollapse = !this.reportCollapse;
      this.toggleContent(this.reportCollapse);
    },
    toggleContent(flag) {
      const container = this.$refs.container;
      const content = this.$refs.content.$el;

      const tl = anime.timeline({
        easing: 'easeOutExpo'
      });
      if (flag) {
        tl.add({
          targets: content,
          translateY: '100%',
          duration: 500
        });
        tl.finished.then(() => {
          anime.set(container, { height: '20px' });
        });
      } else {
        anime.set(container, {
          height: '45%'
        });
        tl.add({
          targets: content,
          translateY: 0,
          duration: 500
        });
      }
    }
  },
  mounted() {
    this.changeCollapse();
  }
};
</script>

<style lang="scss">
.cotton-monitor-report {
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 8;

  box-sizing: border-box;

  width: var(--bottom-width);
  height: var(--bottom-height);
  overflow: hidden;

  // pointer-events: none;

  .toggle-collapse {
    display: flex;
    justify-content: right;
    align-items: center;
    user-select: none;

    font-size: 22px;

    .toggle-icon {
      color: var(--cotton-detection-toggle-icon);
      font-size: 26px;

      pointer-events: auto;
      cursor: pointer;
    }
  }

  .m-card {
    position: absolute;
    left: 0%;
    width: 100%;
    height: 100%;
    user-select: none;

    transform: translateY(100%);

    .el-radio-button {
      pointer-events: auto;
    }

    .device-report {
      margin-top: 0;
      pointer-events: auto;
    }

    .classification {
      display: flex;
      justify-content: flex-end;
    }
  }

  &_content {
    width: 100%;
    height: 100%;
    display: flex;

    &-left {
      --gap: 15px;

      width: 300px;
      height: 100%;

      padding: var(--gap) 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: var(--gap);
      overflow: auto;
      box-sizing: border-box;

      @include scrollar-style-thin;

      .fr01-device-item {
        --state-color: var(--cotton-detection-state-color);
        width: calc(100% - var(--gap) * 2);
        border-radius: 6px;
        background: var(--state-color);
        box-sizing: border-box;
        min-height: calc(33.33% - var(--gap) * 2 / 3);
        flex: none;

        --header-height: 30px;

        &_header {
          text-align: center;
          height: var(--header-height);
          line-height: var(--header-height);
        }

        &_content {
          display: flex;
          justify-content: center;
          align-items: center;
          height: calc(100% - var(--header-height));
        }

        &_handler {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 6px;
          flex-wrap: wrap;
          padding: 5px;

          & > .el-button {
            margin-left: 0;
            height: max-content;
          }
        }
      }
    }

    &-right {
      width: calc(100% - 300px);

      .cotton-battery-info {
        width: 100%;
        justify-content: center;
      }
    }
  }
}
</style>
